import {
    WF_ACTIVITY_REGISTRY,
    WfActivityRegistryEntry
} from '../../feature-core/wf/interface/wf-activity-registry';
import {
    CrCustomerCommentWfProcessStepActivityComponent
} from './component/protected-components/wf/cr-customer-comment-wf-process-step-activity/cr-customer-comment-wf-process-step-activity.component';
import {
    CrCustomerPhoneAvailabilityWfProcessStepActivityComponent
} from './component/protected-components/wf/cr-customer-phone-availability-wf-process-step-activity/cr-customer-phone-availability-wf-process-step-activity.component';
import {
    PmCreatePersonWfProcessStepActivityComponent
} from '../pm/component/protected-components/wf/pm-create-person-wf-process-step-activity/pm-create-person-wf-process-step-activity.component';

export const CR_WF_ACTIVITY_PROVIDER = [{
    provide: WF_ACTIVITY_REGISTRY,
    useValue: [
        ['module_activity:cr.CustomerComment', {
            mainComponent: CrCustomerCommentWfProcessStepActivityComponent
        }],
        ['module_activity:cr.CustomerPhoneContactAvailability', {
            mainComponent: CrCustomerPhoneAvailabilityWfProcessStepActivityComponent
        }],
        ['module_activity:cr.Customer', {
            mainComponent: PmCreatePersonWfProcessStepActivityComponent
        }],
    ] as WfActivityRegistryEntry[],
    multi: true
}];
